import thunderBlueImg from "../../../../images/contents/map/liden/thunder_blue.png";
import thunderLightBlueImg from "../../../../images/contents/map/liden/thunder_light_blue.png";
import thunderYellowGreenImg from "../../../../images/contents/map/liden/thunder_yellow_green.png";
import thunderYellowImg from "../../../../images/contents/map/liden/thunder_yellow.png";
import thunderOrangeImg from "../../../../images/contents/map/liden/thunder_orange.png";
import thunderRedImg from "../../../../images/contents/map/liden/thunder_red.png";

export const configLidenDh = {
    "Controller": {
      "Name": "EXPO_RandomPointExt"
    },
    "Source": {
      "query": {
        "Type": "JSON",
        "url": "%expo_random_point_url%/LIDEN/rect?begin_time=%begin_time%&end_time=%end_time%&latd=%south%:%north%&lond=%west%:%east%",
        "download_max": 8,
        "cache": true
      },
      "data": {
        "Name": "LIDENExpo",
        "Type":"Derived",
        "update_interval": 60,
        "cache": true,
        "retain":true,
        "separation":4,
        "TimeRange": 3600,
        "BoundingBox" : {
          "West": 122,
          "South": 20,
          "East": 154,
          "North": 46
        }
      }
    }
  }
;

export const configLidenLayer = {
  "Name": "LIDENExpo",
  "Renderer": "LightningExt",
  "Attributes": {
    "style": {
      "default": {
        "icon_width": 16,
        "icon_height": 16,
        "icon_offset_x": -8,
        "icon_offset_y": -8,
        "icon": [
          {"ge": 50, "lt": 60, "image": thunderBlueImg},
          {"ge": 40, "lt": 50, "image": thunderLightBlueImg},
          {"ge": 30, "lt": 40, "image": thunderYellowGreenImg},
          {"ge": 20, "lt": 30, "image": thunderYellowImg},
          {"ge": 10, "lt": 20, "image": thunderOrangeImg},
          {"ge": 0, "lt": 10, "image": thunderRedImg}
        ]
      }
    }
  }
};